import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/Notification.css";
import { allnoti, background2 } from "../../Constant";
import { connect } from "react-redux";
import {
    GetNotificationsAction,
    LoadMoreNotificationsAction, ReadAllNotificationAction,
} from "../../redux/actions/notifications";
import config from "../../config";
import moment from "moment";
import { CLEAR_NOTIFICATIONS } from "../../redux/actions/types";

const AllNotification = ({
    auth,
    notifications,
    notificationsCounter,
    getNotifications,
    loadMoreNotifications,
    clearNotificationsCounter,
}) => {

    useEffect(() => {
        getNotifications().then(() => {
            // clearNotificationsCounter();
        });
    }, []);

    return (
        <>
            <Header />
            {/* <!-- All Notificatuions Start Here --> */}
            <section className="all_notifications_here">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="notifications">
                                <div className="heading_wrapper">
                                    <h4>
                                        All Notifications{" "}
                                        {/* <span className="count">10+</span> */}
                                    </h4>
                                    <p>
                                        Keep track of all the relevant alerts
                                        and updates through our notification
                                        page.
                                    </p>
                                </div>

                                <div className="all_read_notifications">
                                    {notifications.data.map(
                                        (singleNotification) => (
                                            <div
                                                className="noti_box"
                                                key={singleNotification.id}
                                            >
                                                <div className="clientDv">
                                                    <div className="img_box">
                                                        <figure>
                                                            <img
                                                                src={
                                                                    singleNotification.user_id ==
                                                                    auth.user.id
                                                                        ? config.returnImage(
                                                                              singleNotification.care_giver
                                                                          )
                                                                        : config.returnImage(
                                                                              singleNotification.user
                                                                          )
                                                                }
                                                                alt=""
                                                            />
                                                        </figure>
                                                    </div>
                                                    <div className="contentDv">
                                                        <h6>
                                                            <span className="bld">
                                                                {singleNotification.user_id ==
                                                                auth.user.id
                                                                    ? singleNotification
                                                                          .care_giver
                                                                          .full_name
                                                                    : singleNotification
                                                                          .user
                                                                          .full_name}
                                                            </span>{" "}
                                                        </h6>
                                                        <p>
                                                            {
                                                                singleNotification.description
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="time_ago">
                                                    <p>
                                                        {moment(
                                                            singleNotification.created_at
                                                        ).fromNow()}
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                                {notifications.next_page_url ? (
                                    <div className="total_data">
                                        <div className="show_more_btn">
                                            <button
                                                className="btn"
                                                onClick={loadMoreNotifications}
                                            >
                                                Show More
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="side_bar_box">
                                <div className="img_box">
                                    <figure>
                                        <img src={background2} alt="" />
                                    </figure>
                                </div>
                                <div className="contentDv">
                                    <h5>Notifications</h5>
                                    <p>
                                        Never miss any important update or alert
                                        again.
                                    </p>
                                    <ul
                                        className="list"
                                        style={{ paddingBottom: 40 }}
                                    >
                                        <li>
                                            <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Monitor your notifications.
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Stay in touch with new job postings.
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Track your payment.
                                        </li>
                                    </ul>
                                    {/* <div className="button-group">
                                        <a href="#" className="btn">
                                            Loem Ipsum
                                        </a>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- All Notificatuions Start Here --> */}
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    notifications: state.notifications.notifications,
    notificationsCounter: state.notifications.counter,
});

const mapDispatchToProps = (dispatch) => ({
    getNotifications : async () => dispatch(await GetNotificationsAction()),
    loadMoreNotifications : async () => dispatch(await LoadMoreNotificationsAction()),
    clearNotificationsCounter : () => dispatch({ type: CLEAR_NOTIFICATIONS }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AllNotification);
